(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("recognitionService", ["$uibModal", recognitionService]);
    function recognitionService($uibModal) {
        var recognitionServiceFactory = {};
        function openRecognitionModel(learningPathInfo, isLearnerView) {
            $uibModal.open({
                templateUrl: "app/modals/recognition/recognitionModalView.html",
                controller: "RecognitionModalCtrl as vm",
                size: "lg",
                animation: false,
                ariaLabelledBy: "modal-title",
                resolve: {
                    data: function () {
                        return {
                            learningPath: learningPathInfo,
                            learnerView: isLearnerView
                        };
                    }
                }
            }).result.catch(angular.noop);
        }
        recognitionServiceFactory.openLearnerView = function (learningPathInfo) {
            openRecognitionModel(learningPathInfo, true);
        };
        recognitionServiceFactory.openAdminView = function (learningPathInfo) {
            openRecognitionModel(learningPathInfo, false);
        };
        return recognitionServiceFactory;
    }
}());
